import React from 'react';
import editIcon from "assets/icons/edit-icon.svg";
import pauseIcon from "assets/icons/pause.svg";
import playIcon from "assets/icons/play.svg";
import { t } from "i18next";
import ConfirmTooltip from 'components/confirmTooltip/ConfirmTooltip';
import styles from "./ListOptions.module.scss";
import cn from 'clsx';

type Props = {
  id: number | string;
  onEdit?: (v: number | string) => void;
  onToggle?: (v: number | string) => void;
  isDisable?: boolean;
  readOnly?: boolean;
};

export const ListOptions: React.FC<Props> = ({
  id,
  onEdit,
  onToggle,
  isDisable,
  readOnly
}) => {

  const handleClickEditModal = (id: number | string) => {
    if (onEdit && !readOnly) {
      onEdit(id);
    }
  }
  const handleToogle = (id: number | string) => {
    if (readOnly) return;
    
    if (onToggle) {
      onToggle(id);
    }
  }

  return (
    <div className={cn("options", styles['options'], readOnly && styles['disabled'])}>
      { onEdit && !readOnly && (
        <div
        className={styles['option']}
        onClick={() => handleClickEditModal(id)}
        >
          <img src={editIcon} alt="Edit Icon" />
        </div>
      )}
      <>
        <div
          data-tooltip-id={`delete-tooltip-${id}`}
          data-tooltip-place="left"
          className={cn(styles['option'])}
        >
          {isDisable ? (
            <img src={playIcon} alt="Play Icon" />
          ) : (
            <img src={pauseIcon} alt="Pause Icon" />
          )}
        </div>
        <ConfirmTooltip
          id={`delete-tooltip-${id}`}
          title={t(!isDisable ?"areYouSureToDisableMirror" : "areYouSureToEnableMirror")}
          onConfirm={() => handleToogle(id)}
          config={{
            clickable: true,
            openEvents: { click: true },
            closeEvents: { click: true, blur: true },
            position: "right",
          }}
        />
      </>


    </div>
  )
};
